import { useFormContext } from 'react-hook-form';

import type { TeamMemberFormSchema } from '../schemas';

export const useTeamMemberFormContext = () => useFormContext<TeamMemberFormSchema>();
